<template>
  <div class="reportsView">
    <div class="records-heading">
      Record Reports
    </div>
    <div class="row">
        <div class="nav-grid col s12 l10">
          <div class="col s6 m4 l3" v-for="(prop, index) in navigation" :key="index">
            <div class="card waves-effect waves-block">
              <div class="card-content">
                <div class="icon-area">
                  <i class="material-icons" v-html="prop.icon"></i>
                </div>
                <div class="card-title">
                  <span v-html="prop.name"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import contentService from '@/services/contentService'
export default {
  name: 'recordsReports',
  data () {
    return {
      navigation: [
      {
        name: 'Stamps',
        icon: 'attach_money'
      }
      ],
      totalPages: 1,
      pagination: {
        per: 50,
        page: 1,
      }
    }
  },
  mounted () {
    this.$_getRecords()
  },
  methods: {
  $_getRecords(){
      contentService.getRecords({per_page: this.pagination.per, page: this.pagination.page})
      .then(res=>{
      this.totalPages = parseInt(res.headers['x-wp-totalpages'])
      this.ready = true
       /// this.$store.commit('SAVE_RECORDS', res.data)
      })
      .catch(err=>{
        window.console.warn(err)
      })			
  },
  }
}
</script>
<style lang="scss" scoped>
.reportsView {
 
}
.nav-grid {
  .card {
    border-radius: 5px;
    max-width: 400px;
    margin: 24px auto;
    width: 100%;
    float: none;
    .card-content {
      text-align: center;
      padding: 12px;
    }
    .card-title {
      margin-bottom: 4px;
      font-size: 13px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: 0.75px;
      text-transform: uppercase;
    }
    .icon-area i {
      font-size: 36px;
      opacity: 0.75;
    }
  }
}
</style>